var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfEmptyStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37631 9.68343L7.92296 7.07696L9.82896 5.24522L7.19381 4.86812L6 2.48369L4.80619 4.86812L2.17104 5.24522L4.07704 7.07696L3.62369 9.68343L6 8.45126L8.37631 9.68343ZM9.70729 11.5L6 9.5777L2.29271 11.5L3.00071 7.4295L0 4.54571L4.14635 3.95236L6 0.25L7.85365 3.95236L12 4.54571L8.99929 7.4295L9.70729 11.5Z",
    fill: "#F19D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.578L2.293 11.5L3 7.43L0 4.55L4.146 3.95L6 0.25V9.578Z",
    fill: "#F19D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfEmptyStarIcon);
export default __webpack_public_path__ + "static/media/half-empty-star-icon.6e06e61bafe5c32dc1df3831001e13f7.svg";
export { ForwardRef as ReactComponent };